const ToggleListItemDetailsNodeSpec = {
	content: "block+",
	selectable:false,
	// defining:true,
	toDOM: () => ['div',{class:"doc-toggleListItem-contents-details"},0],
	parseDOM: [{
		tag: 'div.doc-toggleListItem-contents-details'}]
}

export default ToggleListItemDetailsNodeSpec